import * as React from 'react';
import styled from 'styled-components';

import { Input } from 'components/bootstrap';
import { RowTitle } from 'common/components';
import { useSelectedRows, useSelectedRowsDispatch } from 'common/contexts';
import useExpandedSections from 'components/common/EntityDataTable/hooks/useExpandedSections';
import type { ColumnRenderers } from 'components/common/EntityDataTable';
import type { EntityBase } from 'components/common/EntityDataTable/types';
import type {
  EventProceduresAPIType,
  EventProcedureStepAPIType,
} from 'security-app/hooks/api/eventProceduresAPI.types';

const InputWrapper = styled.div`
  cursor: pointer;
  .form-group {
    margin: 0;
    cursor: pointer;
    .radio {
      margin: 0;
      cursor: pointer;
      input[type='radio'] {
        cursor: pointer;
      }
    }
  }
`;

const SelectCell = ({
  eventProcedure,
}: {
  eventProcedure: EventProceduresAPIType<Array<EventProcedureStepAPIType>>;
}) => {
  const selectedRows = useSelectedRows();
  const selectedRowsDispatch = useSelectedRowsDispatch();

  const isChecked = React.useMemo(
    () =>
      !!selectedRows.find(
        (sProcedure: EventProceduresAPIType<Array<EventProcedureStepAPIType>>) => eventProcedure.id === sProcedure.id,
      ),
    [eventProcedure.id, selectedRows],
  );

  const onChange = React.useCallback(
    (e: React.BaseSyntheticEvent) => {
      if (e.target.checked) {
        selectedRowsDispatch({ type: 'upsert', payload: [eventProcedure] });
      } else {
        selectedRowsDispatch({ type: 'remove', payload: [eventProcedure] });
      }
    },
    [eventProcedure, selectedRowsDispatch],
  );

  return (
    <InputWrapper>
      <Input type="radio" checked={isChecked} onChange={onChange} />
    </InputWrapper>
  );
};

const TitleCell = ({
  eventProcedure,
}: {
  eventProcedure: EventProceduresAPIType<Array<EventProcedureStepAPIType>>;
}) => {
  const { toggleSection } = useExpandedSections();
  const toggleExtraSection = () => toggleSection(eventProcedure.id, 'restFieldsExpandedSection');

  return <RowTitle onClick={toggleExtraSection}>{eventProcedure?.title || 'No title set'}</RowTitle>;
};

// eslint-disable-next-line import/prefer-default-export
export const columnRenderers: ColumnRenderers<EntityBase & EventProceduresAPIType<Array<EventProcedureStepAPIType>>> = {
  attributes: {
    select: {
      staticWidth: 40,
      renderCell: (_: null, eventProcedure: EventProceduresAPIType<Array<EventProcedureStepAPIType>>) => (
        <SelectCell eventProcedure={eventProcedure} />
      ),
    },
    title: {
      renderCell: (_: string, eventProcedure: EventProceduresAPIType<Array<EventProcedureStepAPIType>>) => (
        <TitleCell eventProcedure={eventProcedure} />
      ),
    },
  },
};
